import { getSurveyResponseStatus } from '../../../surveyResponse';
import { SURVEY_RESPONSE_STATUS_TYPE } from '../../../../types/enums';

export const getSurveyResponseStatusOptions = () => [
  { value: SURVEY_RESPONSE_STATUS_TYPE.not_started, text: getSurveyResponseStatus(SURVEY_RESPONSE_STATUS_TYPE.not_started) },
  { value: SURVEY_RESPONSE_STATUS_TYPE.in_progress, text: getSurveyResponseStatus(SURVEY_RESPONSE_STATUS_TYPE.in_progress) },
  { value: SURVEY_RESPONSE_STATUS_TYPE.finished, text: getSurveyResponseStatus(SURVEY_RESPONSE_STATUS_TYPE.finished) },
  { value: SURVEY_RESPONSE_STATUS_TYPE.cancelled, text: getSurveyResponseStatus(SURVEY_RESPONSE_STATUS_TYPE.cancelled) },
];
